var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full flex-col"},[_c('product-header'),_c('features'),_c('easy-to-use'),_c('how-does-it-look'),_c('partner-feedback'),_c('process'),_c('dont-wait'),_c('partners',{attrs:{"white":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }